export type PanelId =
  | 'personal'
  | 'contract'
  | 'finance'
  | 'systems'
  | 'costs'
  | 'systemAccess'
  | 'docs'
  | 'notes'
  | 'dismiss';

export const PANEL_LABELS: Record<PanelId, string> = {
  personal: 'Persönliches',
  contract: 'Vertrag',
  finance: 'Finanzen',
  systems: 'Systeme',
  costs: 'Kosten',
  systemAccess: 'Systemzugänge',
  docs: 'Dokumente',
  notes: 'Notizen',
  dismiss: 'Kündigung',
};

export const FIELD_TO_PANEL: Record<string, PanelId> = {
  name: 'personal',
  surname: 'personal',
  birthday: 'personal',
  is_male: 'personal',
  business_owner: 'personal',
  phone: 'personal',
  mobile: 'personal',
  fax: 'personal',
  email_corp: 'personal',
  email_private: 'personal',
  address: 'personal',
  zip: 'personal',
  city: 'personal',
  country_id: 'personal',
  address2: 'personal',
  zip2: 'personal',
  city2: 'personal',
  country2_id: 'personal',
  status_id: 'contract',
  rank_id: 'contract',
  level_id: 'contract',
  branch_office_id: 'contract',
  contract_type_id: 'contract',
  manager_id: 'contract',
  start_date: 'contract',
  mandateReference: 'contract',
  iban: 'finance',
  bic: 'finance',
  bank_name: 'finance',
  tax_nr: 'finance',
  ust_nr: 'finance',
  wirtschafts_id: 'finance',
  is_small_business: 'finance',
  agent_account_nr: 'finance',
  myjack_login: 'systems',
  jackplus_id: 'systems',
  notes: 'notes',
  dismissed_at: 'dismiss',
  dismissal_reason: 'dismiss',
};

export function getErrorCountsByPanel(errors: Record<string, unknown>): Record<PanelId, number> {
  const counts: Record<PanelId, number> = {
    personal: 0,
    contract: 0,
    finance: 0,
    systems: 0,
    costs: 0,
    systemAccess: 0,
    docs: 0,
    notes: 0,
    dismiss: 0,
  };
  Object.keys(errors).forEach((key) => {
    const panel = FIELD_TO_PANEL[key];
    if (panel) counts[panel] += 1;
  });
  return counts;
}
